(function () {
  function init(root) {
    if (!root || root.__masaraInit) return;
    root.__masaraInit = true;

    /* ============================
       REGION SIZE LABEL MAPPING
       (only S / M / L / XL used)
       ============================ */
    var regionSizeLabels = {
  it: { S: '36–38', M: '40', L: '42', XL: '44' },
  eu: { S: '34–36', M: '38', L: '40', XL: '42' },
  us: { S: '2–4',  M: '6',  L: '8',  XL: '10' },
  uk: { S: '6–8',  M: '10', L: '12', XL: '14' }
};


    /* ============================
       MASARÀ MEASUREMENTS (CM)
       ============================ */
    var masaraData = {
      S:  { bust: '81–86 cm', waist: '63–68 cm', hips: '87–92 cm', bra: '30C–32B' },
      M:  { bust: '87–91 cm', waist: '69–74 cm', hips: '93–97 cm', bra: '34A–34C' },
      L:  { bust: '92–97 cm', waist: '75–80 cm', hips: '98–103 cm', bra: '36B–36D' },
      XL: { bust: '98–102 cm', waist: '81–86 cm', hips: '104–108 cm', bra: '38C–38DD' }
    };

    /* ============================
       STATE (default IT + S)
       ============================ */
    var currentRegion = {
      onepieces: 'it',
      tops: 'it',
      bottoms: 'it'
    };

    var currentSize = {
      onepieces: 'S',
      tops: 'S',
      bottoms: 'S'
    };

    function updateSizeButtonLabels(category) {
      var region = currentRegion[category];
      var map = regionSizeLabels[region] || regionSizeLabels.it;

      var selector = root.querySelector('.size-selector[data-category="' + category + '"]');
      if (!selector) return;

      var btns = selector.querySelectorAll('.size-btn');
      for (var i = 0; i < btns.length; i++) {
        var key = btns[i].getAttribute('data-size'); // S/M/L/XL
        btns[i].textContent = map[key] || key;
      }
    }

    function updateDisplay(category) {
      var sizeKey = currentSize[category];
      var d = masaraData[sizeKey];
      if (!d) return;

      if (category === 'tops') {
        var labelEl = root.querySelector('#tops-size-label');
        var bustEl = root.querySelector('#tops-bust');
        var braEl = root.querySelector('#tops-underbust');

        if (labelEl) labelEl.textContent = sizeKey;
        if (bustEl) bustEl.textContent = d.bust;
        if (braEl) braEl.textContent = d.bra;
        return;
      }

      if (category === 'onepieces') {
        var opLabel = root.querySelector('#onepieces-size-label');
        var opBust = root.querySelector('#onepieces-bust');
        var opHips = root.querySelector('#onepieces-hips');

        if (opLabel) opLabel.textContent = sizeKey;
        if (opBust) opBust.textContent = d.bust;
        if (opHips) opHips.textContent = d.hips;
        return;
      }

      // bottoms
      var bLabel = root.querySelector('#bottoms-size-label');
      var waistEl = root.querySelector('#bottoms-waist');
      var hipsEl = root.querySelector('#bottoms-hips');

      if (bLabel) bLabel.textContent = sizeKey;
      if (waistEl) waistEl.textContent = d.waist;
      if (hipsEl) hipsEl.textContent = d.hips;
    }

    function setActiveWithin(container, selector, activeEl) {
      var els = container.querySelectorAll(selector);
      for (var i = 0; i < els.length; i++) els[i].classList.remove('active');
      activeEl.classList.add('active');
    }

    root.addEventListener('click', function (e) {
      // CATEGORY TABS (generic)
      var tab = e.target.closest('.category-tab');
      if (tab) {
        e.preventDefault();

        var tabsWrap = root.querySelector('.category-tabs');
        if (tabsWrap) setActiveWithin(tabsWrap, '.category-tab', tab);

        var cat = tab.getAttribute('data-category');

        var allContent = root.querySelectorAll('.category-content');
        for (var i = 0; i < allContent.length; i++) allContent[i].classList.remove('active');

        var activePanel = root.querySelector('#' + cat + '-content');
        if (activePanel) activePanel.classList.add('active');

        return;
      }

      // REGION BUTTONS
      var regionBtn = e.target.closest('.region-btn');
      if (regionBtn) {
        e.preventDefault();

        var regionSelector = regionBtn.closest('.region-selector');
        if (!regionSelector) return;

        var cat2 = regionSelector.getAttribute('data-category');
        setActiveWithin(regionSelector, '.region-btn', regionBtn);

        currentRegion[cat2] = regionBtn.getAttribute('data-region');
        updateSizeButtonLabels(cat2);
        updateDisplay(cat2);
        return;
      }

      // SIZE BUTTONS
      var sizeBtn = e.target.closest('.size-btn');
      if (sizeBtn) {
        e.preventDefault();

        var sizeSelector = sizeBtn.closest('.size-selector');
        if (!sizeSelector) return;

        var cat3 = sizeSelector.getAttribute('data-category');
        setActiveWithin(sizeSelector, '.size-btn', sizeBtn);

        currentSize[cat3] = sizeBtn.getAttribute('data-size');
        updateDisplay(cat3);
      }
    });

    // INITIAL RENDER
    updateSizeButtonLabels('onepieces');
    updateSizeButtonLabels('tops');
    updateSizeButtonLabels('bottoms');

    updateDisplay('onepieces');
    updateDisplay('tops');
    updateDisplay('bottoms');
  }

  function boot() {
    document.querySelectorAll('[data-masara-size-guide]').forEach(init);
  }

  boot();

  var obs = new MutationObserver(boot);
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
